export const DOWNLOAD_RESULTS_PDF_FILE_FAILURE = 'DOWNLOAD_RESULTS_PDF_FILE_FAILURE';

export const downloadResultsPdfFileFailure = error => ({
    type: DOWNLOAD_RESULTS_PDF_FILE_FAILURE,
    payload: error,
    error: true,
});
